<template>
  <Details :compName="$t('superDeals')"></Details>
</template>

<script>
import Details from "@/components/widgets/ProductDetails.vue";

export default {
  components: {
    Details,
  },
};
</script>
